export function useWebinarPanelUrl(page) {
    return `${process.env.APP_LIVE_ADMIN_URL}/transmission/${page.webinarKey}?referer=club`;
}
